<script>
	import { onMount, setContext } from 'svelte'
	import { writable } from 'svelte/store'

	import { 
		Header,
		HeroBlock, 
		BenefitsBlock,
		GameBlock,
		ProblemsBlock,
		AutomatizationBlock,
		OpportunitiesBlock,
		DetailsBlock,
		StepsBlock,
		SecurityBlock,
		PricesBlock,
		FormBlock
	} from '@/blocks'

	const ADAPTIVE_BORDER = 834
	const MOBILE_BORDER = 420

	const getAdaptiveType = (width) => {
		return width < MOBILE_BORDER ? 'mobile' : width < ADAPTIVE_BORDER ? 'adaptive' : 'desktop'
	}

	const mobileType = writable(getAdaptiveType(window.innerWidth))

	const resizeHandler = () => {
		$mobileType = getAdaptiveType(window.innerWidth)
	}

	setContext('adaptive', { mobileType })

	onMount(() => {
		window.addEventListener('resize', resizeHandler, true)
	})
</script>


<Header />

<div style="margin-top: 88px;">
	<HeroBlock />
</div>

<BenefitsBlock />

<div style="margin-top: 30px;">
	<GameBlock />
</div>

<div style="margin-top: 168px;">
	<ProblemsBlock />
</div>

<div style="margin-top: 100px;">
	<AutomatizationBlock />
</div>

<div style="margin-top: 100px;">
	<OpportunitiesBlock />
</div>

<div style="margin-top: 150px;">
	<DetailsBlock />
</div>

<StepsBlock />

<div style="margin-top: 150px;">
	<SecurityBlock />
</div>

<div style="margin-top: 150px;">
	<PricesBlock />
</div>

<FormBlock />